import React from "react";
import reactDOM from "react-dom";
import MyRoutes from "./MyRoutes";
import './index.css';


reactDOM.render(
  <MyRoutes />,
  document.getElementById('root')
);